import { render, staticRenderFns } from "./PlpTaskModifiedLog.vue?vue&type=template&id=59919123"
import script from "./PlpTaskModifiedLog.vue?vue&type=script&lang=js"
export * from "./PlpTaskModifiedLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports